/**
 * @generated SignedSource<<ec30c5c68c44929ef13e9a3758ee0b34>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useShouldShowSimilarSoldItems_viewer$data = {
  readonly similarSoldItemsConnection?: {
    readonly totalResults: number | null;
  } | null;
  readonly " $fragmentType": "useShouldShowSimilarSoldItems_viewer";
};
export type useShouldShowSimilarSoldItems_viewer$key = {
  readonly " $data"?: useShouldShowSimilarSoldItems_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShouldShowSimilarSoldItems_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShouldShowSimilarSoldItems_viewer",
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 4
            },
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId"
            },
            {
              "kind": "Literal",
              "name": "requestSourceRole",
              "value": "BUYER"
            }
          ],
          "concreteType": "SimilarSoldItemsConnectionConnection",
          "kind": "LinkedField",
          "name": "similarSoldItemsConnection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalResults",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "914d41592df4ff37147430e20fd321a0";

export default node;
